export default
    {
        quizTimeSettingAllowed: 'Yes',
        questionTimeSettingAllowed: 'No',
        negativeMarkingSettingAllowed: 'Yes',
        passwordQuizSettingAllowed: 'Yes',
        internalizationSettingAllowed: 'Yes'
    };